import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Api } from '../../services/api';
import { RegionService } from '../../services/region.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { jwtDecode } from 'jwt-decode';

@Component({
    selector: 'app-mdl-manage-contact',
    standalone: true,
    imports: [FormsModule,NgSelectModule, CommonModule],
    templateUrl: './mdl-manage-contact.html',
    styleUrl: './mdl-manage-contact.css'

})
export class MdlManageContact implements OnInit {
    private api = inject(Api);
    private regionService = inject(RegionService);

    public regiones: { NombreRegion: string }[] = [];
    public comunas: string [] = [];

    cuentas: any[] = [];
    cuentaSeleccionada: any = null;

    public loggedUserName: string = '';


    propietarioContacto: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public mdl: MatDialogRef<MdlManageContact>
    ) {}

    public contacto: any = {};
    public request: any = {
        cuenta_id: "",
        contacto_id: "",
        nombre: "",
        apellido: "",
        tratamiento: "",
        cargo: "",
        telefono: "",
        celular: "",
        email: "",
        linkedin: "",
        fecha_nacimiento: null,
        aniversario_empresa: null,
        hobbie: "",
        identidad_genero: "",
        calle_env: "",
        ciudad_env: "",
        region_env: "",
        pais: "Chile",
        estado: 0,
        funcion: "",
        observaciones: "",
        ejecutivo_id: ""
    };

    ngOnInit(): void {
        const token = localStorage.getItem('crmtoken');
        if (token) {
            const decodedToken: any = jwtDecode(token);
            this.loggedUserName = `${decodedToken.nombre} ${decodedToken.apellido}`;
        }else{
            this.loggedUserName = 'Usuario desconocido';
        }

        this.api.getAccounts().subscribe((response: any) => {
        if (Array.isArray(response.cuentas)) {
            this.cuentas = response.cuentas;
        } else {
            console.error('getAccounts no retornó un array:', response.cuentas);
            this.cuentas = [];
        }
        });
            

        this.regiones = this.regionService.getRegionesFull();
        console.log(this.data);

        if(this.data.mode === "create"){
        console.log(this.regiones);
        this.request.region_env = this.regiones[0].NombreRegion;
        this.getComunas(this.request.region_env);
        this.request.ciudad_env = this.comunas[0];
        }

        if (this.data.mode === "edit") {
            this.contacto = this.data.contact;
            this.request.cuenta_id = this.contacto.cuenta_id;
            this.request.contacto_id = this.contacto.contacto_id;
            this.request.nombre = this.contacto.nombre || '';
            this.request.apellido = this.contacto.apellido || '';
            this.request.tratamiento = this.contacto.tratamiento || '';
            this.request.cargo = this.contacto.cargo || '';
            this.request.telefono = this.contacto.telefono || '';
            this.request.celular = this.contacto.celular || '';
            this.request.email = this.contacto.email || '';
            this.request.linkedin = this.contacto.linkedin || '';
            this.request.fecha_nacimiento = this.contacto.fecha_nacimiento || '';
            this.request.aniversario_empresa = this.contacto.aniversario_empresa || '';
            this.request.hobbie = this.contacto.hobbie || '';
            this.request.identidad_genero = this.contacto.identidad_genero || '';
            this.request.calle_env = this.contacto.calle_env || '';
            this.request.ciudad_env = this.contacto.ciudad_env || '';
            this.request.region_env = this.contacto.region_env || '';
            this.request.pais = this.contacto.pais || '';
            this.loggedUserName = this.contacto.ejecutivo
            ? `${this.contacto.ejecutivo.nombre} ${this.contacto.ejecutivo.apellido}`
            : this.loggedUserName;
        }

        if (this.request.region_env) {
    this.getComunas(this.request.region_env);

    setTimeout(() => {
      this.request.ciudad_env = this.contacto.ciudad_env || '';
    }, 100);
    }

}

  closeMdl(){
    this.mdl.close();
  }

  updateContact() {
    this.api.showLoading();
    try{
        this.api.updateContact(this.request).subscribe({
            next:(data:any) =>{
                setTimeout(() => {
                    this.api.hideLoading();
                    window.location.reload();
                }, 500);
    },
    error: (err:any) => {
        console.error(err);
    }
        })
    } catch (err) {
        console.error(err);
    }}


  createContact() {
    this.request.cuenta_id = this.cuentaSeleccionada;
    this.api.showLoading();
    try {
        this.api.createContact(this.request).subscribe({
            next: (data:any) => {
                setTimeout(() => {
                    this.api.hideLoading();
                    window.location.reload();
                }, 500);
            },
            error: (error:any) => {
                console.error(error);
            }
        });
    } catch (err) {
        console.error(err);
    }
  }    

getComunas(region:string){
    this.comunas = this.regionService.getComunasByRegion(region);
    if (!this.request.ciudad_env) {
    this.request.ciudad_env = this.comunas[0];
  }         
  }
















































}